import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Image } from '@/components/ui/image';

export default function PortfolioTile({ item, onOpen }) {
  return (
    <button
      type="button"
      onClick={() => onOpen(item)}
      className={`group relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03] text-left min-h-[260px] ${item.span}`}
    >
      <Image
        src={item.src}
        alt={`${item.title} — ${item.client}`}
        quality={65}
        className="absolute inset-0 w-full h-full transition-transform duration-700 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B]/90 via-[#0B0B0B]/10 to-transparent opacity-80 group-hover:opacity-100 transition-opacity" />
      <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-[#0B0B0B]/60 backdrop-blur text-[10px] uppercase tracking-[0.16em] text-white/80">
        {item.category}
      </span>
      <div className="absolute bottom-0 inset-x-0 p-5 flex items-end justify-between gap-3">
        <div>
          <p className="font-display font-semibold text-white text-lg">{item.title}</p>
          <p className="text-xs text-white/60 mt-0.5">{item.client}</p>
        </div>
        <span className="w-10 h-10 rounded-full bg-[#2563EB] flex items-center justify-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
          <ArrowUpRight className="w-4 h-4 text-white" />
        </span>
      </div>
    </button>
  );
}